import axios from "axios";
import { onReqFulfilled, onReqRejected, onResFulfilled, onResRejected } from "./helpers";
import env from "src/config/env";

const api = axios.create({
	baseURL: env.REACT_APP_API_BASE_URL,
	headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use(onReqFulfilled, onReqRejected);
api.interceptors.response.use(onResFulfilled, onResRejected);

export const validateToken = () => api.post("/auth/validate_token");

export const dashboard = () => api.get("/users/dashboard");

export const logoutFn = () => api.post("/auth/logout");

export const changeDefaultPassword = (data) => api.put("/auth/update-default-password", data);

export const getReconciliation = (params) => api.get("/reconciliation", { params });

export const reconciliationExport = () => api.get("/reconciliation/export", { responseType: "blob" });

export const getBusinessOrganizationTypes = () => api.get("/organization-types");

export default api;
